export default __webpack_public_path__ + "static/media/Spectrophotometer-vector.0c766816.svg";